import React, { useCallback, useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import { Hint } from '../../types/Hint'
import { LibraryOscCard } from './LibraryOscCard'

export const LastPost = () => {

    const [hint, setHint] = useState<Hint[]>()
    const api = useApi()

    const loadLastHint = useCallback(async () => {
        await api.get("client/library/hints?limit=3").then(res => {
            setHint(res.data)
        }).catch(console.log)
    }, [api, setHint])

    useEffect(() => {
        loadLastHint()
    }, [loadLastHint])

    return (
        <>
            <div className='text-gray-600 font-semibold'>Últimas Dicas</div>
            <div className='grid grid-cols-3 gap-x-6 w-full'>
                {hint?.map(item => (
                    <LibraryOscCard type="hints" item={item} download />
                ))}
            </div>
        </>
    )
}